import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRACTOR = {
  nickname: 'PRODUCTS.TRACTOR.shortname',
  properties: [
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_TYVERI' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' }
        ]
      }
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      TRACTOR: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{4}/)
      ]]
    },
    {
      name: 'licenseYear', key: 'DRIVER_LICENSE_YEAR', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO' },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO'},
    { name: 'tffVehicleGroupCode', key: 'TFF_VEHICLE_GROUP_CODE', group: 'OBJECT_INFO' },
    {
      name: 'vehicleDailyUsage', key: 'VEHICLE_DAILY_USAGE_MOBILE_HOME', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_DAILY_USAGE.USED_OUTSIDE_HOUSEHOLD', value: 'USED_OUTSIDE_HOUSEHOLD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_DAILY_USAGE.NOT_USED_OUTSIDE_HOUSEHOLD', value: 'NOT_USED_OUTSIDE_HOUSEHOLD' },
        ]
      }
    },
    {
      name: 'tractorUsageArea', key: 'VEHICLE_USAGE_AREA_TRACTOR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_USAGE_AREA.USED_IN_FOREST', value: 'USED_IN_FOREST' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_USAGE_AREA.NOT_USED_IN_FOREST', value: 'NOT_USED_IN_FOREST' },
        ]
      }
    },
    {
      name: 'vehicleCommercialUse', key: 'VEHICLE_COMMERCIAL_USE_TRACTOR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleAlarm', key: 'VEHICLE_ALARM', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleType', key: 'TRACTOR_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.TRACTOR_UNDER_400_KG', value: 'TRACTOR_UNDER_400_KG' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.TRACTOR_OWN_USE', value: 'TRACTOR_OWN_USE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.TRACTOR_PAID_WORK', value: 'TRACTOR_PAID_WORK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.COMBINE_HARVESTER', value: 'COMBINE_HARVESTER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.ATV', value: 'ATV' },
        ]
      }
    },
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      TRACTOR_SUM_INSURED_RANGE: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.min(0),
        Validators.max(500000)
      ]]
    },
    {
      name: 'vehicleDriverAccident', key: 'VEHICLE_DRIVER_ACCIDENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleMortage', key: 'VEHICLE_MORTAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
  ],
  icon:'tractor'
};
